(function ($) {
  $(function () {

 var POPUP_ID = 'custom-kitchen-popup';
    var STORAGE_KEY = 'kitchenPopupHiddenUntil';
    var SHOW_DELAY_MS = 3000;
    var HIDE_DAYS = 7;

    function $popup() {
      return $('#' + POPUP_ID);
    }

    function nowTs() {
      return Date.now();
    }

    function daysToMs(days) {
      return days * 24 * 60 * 60 * 1000;
    }

    function getHiddenUntil() {
      var v = localStorage.getItem(STORAGE_KEY);
      if (!v) return 0;
      var ts = parseInt(v, 10);
      return isNaN(ts) ? 0 : ts;
    }

    function setHiddenForDays(days) {
      var until = nowTs() + daysToMs(days);
      localStorage.setItem(STORAGE_KEY, String(until));
    }

    function shouldShowPopup() {
      return nowTs() > getHiddenUntil();
    }

    function openPopup() {
      var $el = $popup();
      if (!$el.length) return;
      $el.css('display', 'flex').addClass('is-open');
    }

    // setCooldown = true => upis u localStorage
    function closePopup(setCooldown) {
      var $el = $popup();
      if (!$el.length) return;

      $el.css('display', 'none').removeClass('is-open');

      if (setCooldown) {
        setHiddenForDays(HIDE_DAYS);
      }
    }

    // Inline onclick koristi ovo: closeKitchenPopup() => upisuje cooldown
    window.closeKitchenPopup = function () {
      closePopup(true);
    };

    // 1) show posle 3s, samo ako nije cooldown
    if (shouldShowPopup()) {
      setTimeout(function () {
        if (shouldShowPopup()) {
          openPopup();
        }
      }, SHOW_DELAY_MS);
    }

    // 2) X klik => zatvori + upiši 7 dana
    $(document).on('click', '#' + POPUP_ID + ' .close-btn', function (e) {
      e.preventDefault();
      closePopup(true);
    });

    // 3) outside klik (na overlay) => samo zatvori, BEZ localStorage
    $(document).on('click', '#' + POPUP_ID, function (e) {
      if (e.target === this) {
        closePopup(false);
      }
    });

    // 4) ESC (opciono) => samo zatvori, BEZ localStorage
    $(document).on('keydown', function (e) {
      if (e.key === 'Escape') {
        var $el = $popup();
        if ($el.length && ($el.is(':visible') || $el.hasClass('is-open'))) {
          closePopup(false);
        }
      }
    });

    $('.nav-button').on('click', function (e) {
      e.preventDefault();
      $(this).toggleClass('active');
      $('.navigation-floating').toggleClass('opened');
      $('.overlay-black').addClass('active');

    });

    $('.nav-button.active').on('click', function () {
      $(this).removeClass('active');
      $('.navigation-floating.opened').removeClass('opened');
    });

    /*
     * Navbar fixed 
     */
    $(window).on('scroll', function () {
      if ($(this).scrollTop() > 1) {
        $('.site-header').addClass('navbar-fixed-top');
      } else {
        $('.site-header').removeClass('navbar-fixed-top');
      }
    });

    /*
     * Toggle burger menu on mobile
     */
    $('.menu-btn-burger').on('click', function () {
      $('#nav-icon').toggleClass('open-custom-menu');
      $(".mobile-menu").toggleClass('sliding-open');
    });

    /* 
     * Owl carousel
     */
    $('.owl-room-card').owlCarousel({
      margin: 40,
      items: 3,
      loop: true,
      autoplay: true,
      autoplayTimeout: 4500,
      nav: true,
      dots: false,
      animateOut: 'fadeOut',
      navText: ["<i class='icon-angle-left'></i>", "<i class='icon-angle-right'></i>"],
      // navContainer: '#customNav',
      responsive: {
        0: {
          items: 1
        },
        700: {
          items: 2,
          margin: 0,
        },
        1200: {
          items: 3,
        }
      }
    });

    $('.owl-services-slider').each(function () {
      const $slider = $(this);
      const $navContainer = $slider.closest('.block-services-slider-wrap').find('.js-services-slider-nav');

      $slider.owlCarousel({
        items: 1,
        margin: 0,
        loop: true,
        autoplay: false,
        nav: true,
        dots: false,
        navContainer: $navContainer,
        navText: ["<i class='icon-arrow-left'></i>", "<i class='icon-arrow-right'></i>"]
      });
    });

    /*
     * Video modal 
     */
    $("body").on("click", "#play-video-modal", function (e) {
      e.preventDefault();
      $("#video-modal").modal("show");
      $("#video-modal iframe")[0].src += "?autoplay=1";
    });

    $("#video-modal").on('hidden.bs.modal', function (e) {
      var videoUrl = $("#video-modal iframe")[0].src;
      videoUrl = videoUrl.replace("?autoplay=1", "");
      $("#video-modal iframe")[0].src = videoUrl;
    });

    /*
     * Youtube lazy loading
     */
    $('#play-video-btn').on('click', function (e) {
      e.preventDefault();
      $('#youtubeModal').modal('show');
    });

    $("#youtubeModal").on('hidden.bs.modal', function (e) {
      $("#youtubeModal iframe").attr("src", $("#youtubeModal iframe").attr("src"));
    });



    /*
     * Scroll up button
     */
    $(window).scroll(function () {
      if ($(this).scrollTop() > 150) {
        $('.scroll-to-top').addClass('show');
      } else {
        $('.scroll-to-top').removeClass('show');
        $('.scroll-to-top').addClass('animated bounceOutDown');
        $('.scroll-to-top').removeClass('animated bounceOutUp');
        $('.scroll-to-top i').css('transform', 'rotateY(0) scale(1)');
      }
    });

    $('.scroll-to-top').on("click", function () {
      $('.scroll-to-top').addClass('animated bounceOutUp');
      $('.scroll-to-top i').css('transform', 'rotateY(180deg) scale(1.2)');
      $("html, body").animate({
        scrollTop: 0
      }, 1000);
      return false;
    });

    /*
     * Smooth scroll for same-page hash links
     */
    $('body').on('click', 'a[href*="#"]', function (e) {
      const href = $(this).attr('href') || '';

      if (!href || href === '#' || href.indexOf('#') === -1) {
        return;
      }

      const url = new URL(href, window.location.href);
      const isSamePage = url.pathname === window.location.pathname && url.hostname === window.location.hostname;

      if (!isSamePage || !url.hash) {
        return;
      }

      const $target = $(url.hash);
      if (!$target.length) {
        return;
      }

      e.preventDefault();

      const headerHeight = $('.site-header').outerHeight() || 0;
      const targetTop = Math.max($target.offset().top - headerHeight, 0);

      $('html, body').animate({ scrollTop: targetTop }, 700);
    });

    /*
     * Lightbox gallery
     */
    $('.gallery-images').lightGallery({
      selector: '.gallery-item',
      exThumbImage: 'data-exthumbimage',
      share: true,
      download: true,
      rotate: false,
      showThumbByDefault: true,
      loop: false,
      slideEndAnimatoin: false, 
      thumbnail: true,
      allowMediaOverlap: true,
      toggleThumb: true,
      youtubePlayerParams: {
        loadYoutubeThumbnail: true,
        youtubeThumbSize: 'default',
        modestbranding: 1,
        showinfo: 0,
        rel: 0
      }
    });

    /*
     * Referenzen filter (without page refresh)
     */
    const $referenzenFilters = $('[data-referenzen-filters]');
    const $referenzenItems = $('[data-referenz-item]');
    const $referenzenLoadMore = $('[data-referenzen-load-more]');
    const itemsPerPage = 6;

    if ($referenzenFilters.length && $referenzenItems.length) {
      let selectedFilter = 'all';
      let visibleItems = itemsPerPage;

      const updateReferenzenGrid = function () {
        const $matchedItems = $referenzenItems.filter(function () {
          const terms = String($(this).data('terms') || '').split(' ');
          return selectedFilter === 'all' || terms.includes(selectedFilter);
        });

        $referenzenItems.addClass('is-hidden');
        $matchedItems.slice(0, visibleItems).removeClass('is-hidden');

        if ($referenzenLoadMore.length) {
          const shouldShowLoadMore = $matchedItems.length > visibleItems;
          $referenzenLoadMore.toggle(shouldShowLoadMore);
        }
      };

      $referenzenFilters.on('click', '.referenzen-filter', function () {
        selectedFilter = $(this).data('filter');
        visibleItems = itemsPerPage;

        $referenzenFilters.find('.referenzen-filter').removeClass('is-active');
        $(this).addClass('is-active');
        updateReferenzenGrid();
      });

      $referenzenLoadMore.on('click', function () {
        visibleItems += itemsPerPage;
        updateReferenzenGrid();
      });

      updateReferenzenGrid();
    }

    /*
     * Referenzen open lightbox (no single page)
     */
    $('body').on('click', '[data-open-referenz-gallery]', function (e) {
      e.preventDefault();

      const galleryId = $(this).data('open-referenz-gallery');
      if (!galleryId) {
        return;
      }

      const $firstGalleryImage = $('#' + galleryId).find('.gallery-item').first();
      if ($firstGalleryImage.length) {
        $firstGalleryImage.trigger('click');
      }
    });

    /*
     * Counter numbers
     */
    const $counterNumbers = $('.block-counter-number__value');

    if ($counterNumbers.length) {
      const animateCounter = function (el) {
        const original = (el.textContent || '').trim();
        const match = original.match(/-?\d+(?:[.,]\d+)?/);

        if (!match) {
          return;
        }

        const numberText = match[0];
        const startIndex = match.index || 0;
        const endIndex = startIndex + numberText.length;
        const prefix = original.slice(0, startIndex);
        const suffix = original.slice(endIndex);
        const decimals = (numberText.split(/[.,]/)[1] || '').length;
        const normalized = numberText.replace(',', '.');
        const target = parseFloat(normalized);
        const duration = 2400;
        let startTime = null;

        if (Number.isNaN(target)) {
          return;
        }

        const step = function (timestamp) {
          if (!startTime) {
            startTime = timestamp;
          }

          const progress = Math.min((timestamp - startTime) / duration, 1);
          const value = target * progress;
          const renderedValue = decimals > 0 ? value.toFixed(decimals) : Math.round(value).toString();
          el.textContent = prefix + renderedValue.replace('.', ',') + suffix;

          if (progress < 1) {
            window.requestAnimationFrame(step);
          } else {
            el.textContent = original;
          }
        };

        window.requestAnimationFrame(step);
      };

      if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver(function (entries, obs) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              animateCounter(entry.target);
              obs.unobserve(entry.target);
            }
          });
        }, { threshold: 0.35 });

        $counterNumbers.each(function () {
          observer.observe(this);
        });
      } else {
        $counterNumbers.each(function () {
          animateCounter(this);
        });
      }
    }



    /*
     * Mmenu light 
     */
    var menu = new MmenuLight(
      document.querySelector('#my-menu'),
      'all'
    );
    if (menu) {
      var navigator = menu.navigation({
        // selectedClass: 'Selected',
        // slidingSubmenus: true,
        theme: 'light',
        title: 'Menü'
      });

      var drawer = menu.offcanvas({
        position: 'right'
      });

      //  Open the menu.
      document.querySelector('#nav-icon')
        .addEventListener('click', evnt => {
          evnt.preventDefault();
          drawer.open();
        });

      $(".mob-menu-close").click(function () {
        drawer.close();
      });
    }

  });
})(jQuery);
